import Link from "next/link";
import { pagePath } from "@/lib/address";
import { CookieSettingsLink } from "@/components/shell/CookieBanner";
import { InstagramIcon, WhatsAppIcon } from "@/components/ui/BrandIcons";

/**
 * The links the website's footer has, which the desktop shows at the end of
 * every page and the phone's menu lists. The pages in the app open in place;
 * WhatsApp, Instagram and the complaints book are someone else's sites.
 *
 * The footer closes the page: nothing goes after it or pads under it. It is
 * sticky at a viewport's height from the top, which only ever holds it down
 * against the bottom of what it is in -- #page or a StackedPage, both at least
 * the window's height -- so a short page has it at the bottom of the window
 * rather than part way up with ground beneath.
 */
export const COMPANY_LINKS = [
  { label: "Sobre Nós", page: "sobre-nos" },
  { label: "Eventos passados", page: "eventos-passados" },
  { label: "Contactos", page: "contactos" },
  { label: "Perguntas Frequentes", page: "perguntas-frequentes" },
];

export const WHATSAPP_GROUP = { label: "Grupo de WhatsApp", href: "https://chat.whatsapp.com/EThkfCx41q6JGu9bVjJiIe" };
export const FACEBOOK = { label: "Facebook", href: "https://www.facebook.com/montanhasdentro" };
export const INSTAGRAM = { label: "Instagram", href: "https://www.instagram.com/montanhasdentro/" };
export const COMPLAINTS_BOOK = { label: "Livro de reclamações", href: "https://www.livroreclamacoes.pt/" };

export const LEGAL_PAGES = [
  { label: "Política de Cookies", page: "politica-de-cookies" },
  { label: "Política de Privacidade", page: "politica-de-privacidade" },
  { label: "Termos e Condições", page: "termos-e-condicoes" },
  { label: "Entidades RAL", page: "entidades-ral" },
];

export function SiteFooter() {
  return (
    <footer className="mt-12 hidden border-t border-line-strong/60 bg-surface/80 text-[13px] text-ink-soft desk:sticky desk:top-[100dvh] desk:block">
      <div className="mx-auto max-w-[1200px] px-6">
        <nav className="flex items-center gap-5 border-b border-line py-3 text-[14px] font-semibold text-ink" aria-label="Montanhas Dentro">
          {COMPANY_LINKS.map((link) => (
            <Link key={link.page} href={pagePath(link.page)!} className="hover:text-brand">
              {link.label}
            </Link>
          ))}
          <span className="ml-auto flex items-center gap-5">
            <a href={WHATSAPP_GROUP.href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-brand">
              <WhatsAppIcon size={16} /> {WHATSAPP_GROUP.label}
            </a>
            <a href={INSTAGRAM.href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-brand">
              <InstagramIcon size={16} /> {INSTAGRAM.label}
            </a>
          </span>
        </nav>
        <div className="flex items-center gap-5 py-3">
          <nav className="flex flex-wrap items-center gap-5" aria-label="Informação legal">
            <a href={COMPLAINTS_BOOK.href} target="_blank" rel="noopener noreferrer" className="hover:text-brand">
              {COMPLAINTS_BOOK.label}
            </a>
            {LEGAL_PAGES.slice(0, 1).map((link) => (
              <Link key={link.page} href={pagePath(link.page)!} className="hover:text-brand">
                {link.label}
              </Link>
            ))}
            <CookieSettingsLink className="hover:text-brand" />
            {LEGAL_PAGES.slice(1).map((link) => (
              <Link key={link.page} href={pagePath(link.page)!} className="hover:text-brand">
                {link.label}
              </Link>
            ))}
          </nav>
          <span className="ml-auto whitespace-nowrap">© {new Date().getFullYear()} Montanhas Dentro</span>
        </div>
      </div>
    </footer>
  );
}
